export enum StorageNames {
    USER = 'user'
}
